import config from 'configDir/index';
import { get } from './http';

const statisticUrl = '/violation/addressStatistic';
const { governanceUrl } = config;

const getStatisticPageListService = get(`${statisticUrl}/getStatisticPageList`, governanceUrl);

const getVehicleByAddressService = get(`${statisticUrl}/getVehicleByAddress`, governanceUrl);

export { getStatisticPageListService, getVehicleByAddressService };
